export { default as Img200 } from './processed/200/Mayans-S1.jpg';
export { default as Img400 } from './processed/400/Mayans-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Mayans-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Mayans-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Mayans-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      224,
      49,
      45
    ],
    "_population": 2274,
    "_hsl": [
      0.0037243947858473,
      0.7427385892116182,
      0.5274509803921569
    ]
  },
  "LightVibrant": {
    "_rgb": [
      247,
      214,
      149
    ],
    "_population": 155,
    "_hsl": [
      0.11054421768707483,
      0.8596491228070178,
      0.7764705882352941
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      121,
      32,
      31
    ],
    "_population": 682,
    "_hsl": [
      0.001851851851851852,
      0.5921052631578947,
      0.2980392156862745
    ]
  },
  "Muted": {
    "_rgb": [
      179,
      156,
      119
    ],
    "_population": 917,
    "_hsl": [
      0.10277777777777784,
      0.28301886792452824,
      0.584313725490196
    ]
  },
  "LightMuted": {
    "_rgb": [
      200,
      171,
      130
    ],
    "_population": 738,
    "_hsl": [
      0.0976190476190476,
      0.38888888888888884,
      0.6470588235294117
    ]
  },
  "DarkMuted": {
    "_rgb": [
      49,
      56,
      64
    ],
    "_population": 616,
    "_hsl": [
      0.5888888888888889,
      0.1327433628318584,
      0.22156862745098038
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Mayans-S1.js